import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/scss/index.scss'
import VueClipboard from 'vue-clipboard2'
import VueMeta from 'vue-meta'
import PrimeVue from 'primevue/config'; 
import ConfirmationService from 'primevue/confirmationservice';
import 'primevue/resources/themes/saga-blue/theme.css';    
import 'primevue/resources/primevue.min.css';              
import 'primeicons/primeicons.css';    

Vue.config.productionTip = false;

document.body.addEventListener('touchstart',function(){});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

Vue.use(VueMeta);
Vue.use(VueClipboard);
Vue.use(PrimeVue); 
Vue.use(ConfirmationService);

